import http from './http'

export default class SiteCheckApi {
	/*违禁词检测*/
	static checkWord(params) {
		return http.httpGet('/page/checkWord', params)
	}

	/*死链检测*/
	static deadLinks(params) {
		return http.httpGet('/page/deadLinks', params)
	}
	/*获取死链检测结果*/
	static getDeadLinks(params) {
		return http.httpGet('/page/getDeadLinks', params)
	}

	/**
	 * 获取上次违禁词检测记录
	 * @param params
	 * @returns {*}
	 */
	static getLastWord(params) {
		return http.httpGet('/page/lastWord', params)
	}

	static getlastXenus(params) {
		return http.httpGet('/page/getOldDeadLinks', params)
	}
}
